/** Ventas acumuladas en ventana móvil (30 días) → nivel. */
export const UMBRAL_NIVEL_2 = 10;
export const UMBRAL_NIVEL_3 = 30;
export const UMBRAL_NIVEL_4 = 60;
export const UMBRAL_NIVEL_5 = 110;

/** Días que cuenta cada venta para el nivel. */
export const VENTANA_VENTAS_DIAS = 30;

/** Duración trial nivel 5 (beneficios / comisión como N5). */
export const TRIAL_DIAS = 30;

/** Overlay "VENDIDO" en listado (horas). */
export const BADGE_VENDIDO_HORAS = 3;

/** Bloqueo de nuevas publicaciones si hay deuda y… */
export const MAX_VENTAS_IMPAGAS_BLOQUEO = 5;
export const DEUDA_ARS_BLOQUEO = 50000;

/** Alias Mercado Pago (transferencia manual). */
export const MP_ALIAS_COBRANZAS = import.meta.env.VITE_MP_ALIAS || 'Kevinmaggio.mp';

/** WhatsApp soporte comisión manual (número internacional sin +). */
export const WHATSAPP_COMISION_SOPORTE = import.meta.env.VITE_WHATSAPP_COMISION || '5491162399695';

export const MSJ_WHATSAPP_COMISION_MANUAL =
  'Hola no puedo pagar por el link.. te paso por alias y comparto comprobante';

export function urlWhatsappComisionManual() {
  const t = encodeURIComponent(MSJ_WHATSAPP_COMISION_MANUAL);
  return `https://wa.me/${WHATSAPP_COMISION_SOPORTE}?text=${t}`;
}

/** % comisión plataforma por nivel (1 = nivel 1 … 5 = nivel 5). */
export const COMISION_PCT_POR_NIVEL = {
  1: 5,
  2: 4,
  3: 3,
  4: 2,
  5: 1,
};
